import React from "react";

/* Gedeeld form-veld met mono-label — gebruikt door LeadCreateModal en BulkOutreachModal. */
export function FieldX({ label, children, testid, full }) {
    return (
        <label className={`block ${full ? "sm:col-span-2" : ""}`} data-testid={testid}>
            <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-[var(--jr-text-3)] mb-1 block">{label}</span>
            {children}
        </label>
    );
}

export default FieldX;
